import React from 'react';

function Knight() {
    return(
        <div id='knight'></div>
    );
}

export default Knight;